// extracted by mini-css-extract-plugin
export var drawerPaper = "_26-0";
export var itemImage = "_26-1";